import { AlertTriangle, RefreshCw } from "lucide-react";

const SkeletonCard = ({ tall }) => (
  <div className={`ops-card ops-skeleton-card ${tall ? "is-tall" : ""}`} aria-hidden="true">
    <span className="ops-skeleton" style={{ width: "40%" }} />
    <span className="ops-skeleton is-lg" style={{ width: "32%" }} />
    <span className="ops-skeleton" style={{ width: "70%" }} />
    {tall && <span className="ops-skeleton is-block" />}
  </div>
);

export const DashboardSkeleton = () => (
  <div className="ops-skeleton-page" data-testid="dashboard-loading" aria-busy="true" aria-live="polite">
    <span className="sr-only">Loading operations overview…</span>
    <div className="ops-metric-grid">
      {[0, 1, 2, 3].map((index) => (
        <SkeletonCard key={index} />
      ))}
    </div>
    <div className="ops-main-row">
      <SkeletonCard tall />
      <SkeletonCard tall />
    </div>
  </div>
);

export const DashboardError = ({ message, onRetry, inline }) => (
  <div className={`ops-card ops-error-state ${inline ? "is-inline" : ""}`} role="alert" data-testid={inline ? "dashboard-refresh-error" : "dashboard-error"}>
    <span className="ops-empty-icon is-error">
      <AlertTriangle size={18} />
    </span>
    <div className="ops-error-copy">
      <strong>{inline ? "The latest figures could not be refreshed" : "The operations overview could not be loaded"}</strong>
      <p>{message}</p>
    </div>
    <button type="button" className="ops-secondary-button" onClick={onRetry} data-testid="dashboard-retry-button">
      <RefreshCw size={15} aria-hidden="true" /> Try again
    </button>
  </div>
);
